import { useEffect, useState } from "react";

import useAPI, { APIProvider } from "@/src/contexts/api-context";

export default function ExamplesPage() {
  return (
    <APIProvider baseURL="https://cuanto.app" userId={192}>
      <Examples />
    </APIProvider>
  );
}

function Examples() {
  const data = useExamples();

  if (!data) return <span>Loading...</span>;

  return <pre>{JSON.stringify(data, null, 2)}</pre>;
}

function useExamples() {
  const [data, setData] = useState<object | null>(null);
  const { apiClient } = useAPI();

  useEffect(() => {
    async function fetchExamples() {
      const { data } = await apiClient.get("/examples");
      console.log(data);
      setData(data);
    }

    fetchExamples();
  }, []);

  return data;
}
